export default class UrlParser {
  private static instances: { [key: string]: UrlParser } = {};

  private readonly location: Location | URL;
  private parsedUrl: URLSearchParams | null = null;
  private parsedFapiFormData: { [key: string]: string | null } | null = null;

  private constructor(location: Location | URL) {
    this.location = location;
  }

  static getInstance(location: URL | null = null): UrlParser {
    if (!UrlParser.instances.hasOwnProperty(String(location))) {
      UrlParser.instances[String(location)] = new UrlParser(
        location || window.location,
      );
    }

    return UrlParser.instances[String(location)];
  }

  getParam(param: string): string | null {
    if (this.parsedUrl === null) {
      this.parseUrl();
    }

    if (this.parsedUrl === null) {
      return null;
    }

    return this.parsedUrl.get(param);
  }

  getParamFromFormData(param: string): string | null {
    if (this.parsedUrl === null) {
      this.parseUrl();
    }

    if (this.parsedUrl === null) {
      return null;
    }

    if (this.parsedFapiFormData === null) {
      this.parseFapiFormData();
    }

    if (this.parsedFapiFormData === null) {
      return null;
    }

    return this.parsedFapiFormData[param] || null;
  }

  private parseUrl(): void {
    this.parsedUrl = new URLSearchParams(this.location.search);
  }

  isHttps(): boolean {
    return this.location.protocol === "https:";
  }

  isWebFapiPreview(): boolean {
    const href = this.location.href.toLowerCase();

    return href.includes("//web.fapi.") && href.includes("/preview");
  }

  private parseFapiFormData() {
    const encodedData = String(this.getParam("fapi-form-data"));

    if (!encodedData || encodedData === "null") {
      this.parsedFapiFormData = null;
      return;
    }

    const decodedJson = decodeURIComponent(atob(encodedData));
    this.parsedFapiFormData = JSON.parse(decodedJson);
  }
}
